// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"7cdc8359","556":"04bca116"}[chunkId] + ".chunk.css";
};